/**
 * The top bar: the Oraclase logo, linking to the home page, and a caption
 * on the left; on the right the environment warning (dev/test server) and
 * the System / Database status. Navigation, including the Login entry,
 * lives in the side menu (SideNav).
 */
import React from "react";
import oraclaseLogo from "../assets/oraclase_logo_black_bg.png";
import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DevServerBanner from "./DevServerBanner";
import BackendStatus from "./BackendStatus";

const NavBarTop = () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      sx={{
        px: { xs: 1.5, md: 2.5 },
        py: 1,
        minHeight: "74px",
        boxSizing: "border-box",
        background: "linear-gradient(90deg, #0d1117 0%, #121a26 100%)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 6px 16px rgba(0,0,0,0.18)",
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
        <Box
          component={Link}
          to="/"
          aria-label="Go to home page"
          sx={{
            px: 0.5,
            py: 0.2,
            borderRadius: 0,
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <img
            src={oraclaseLogo}
            alt="Oraclase"
            style={{ height: "40px", width: "120px", objectFit: "contain", filter: "brightness(1.15) contrast(1.08)" }}
          />
        </Box>
        <Typography
          variant="subtitle1"
          noWrap
          sx={{
            color: "rgba(255,255,255,0.95)",
            fontWeight: 600,
            letterSpacing: 0.2,
            display: { xs: "none", sm: "block" },
          }}
        >
          Oraclase Cloud Application
        </Typography>
      </Stack>

      {/* Environment + health, right-aligned: the warning chip (only on a
          dev/test backend) and the two status lights. */}
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexShrink: 0 }}>
        <DevServerBanner variant="chip" />
        <BackendStatus />
      </Stack>
    </Stack>
  );
};

export default NavBarTop;
